import { Link } from "react-router-dom";
import { SURVEY_META } from "../lib/survey-config";

export function Done() {
  return (
    <div className="flex flex-1 flex-col justify-center gap-6">
      <header className="space-y-3">
        <h1 className="text-3xl font-semibold tracking-tight md:text-4xl">
          {SURVEY_META.outroTitle}
        </h1>
        <p className="text-fg-muted leading-relaxed">{SURVEY_META.outroBody}</p>
      </header>
      <div className="flex flex-wrap items-center gap-3">
        <Link
          to="/"
          className="inline-flex w-fit items-center gap-2 rounded-input bg-accent px-5 py-3 text-sm font-medium text-accent-fg transition hover:opacity-90"
        >
          ← Zurück zum Start
        </Link>
        <Link
          to="/timeline"
          className="inline-flex w-fit items-center gap-2 rounded-input border border-border px-5 py-3 text-sm font-medium text-fg transition hover:bg-bg-elevated"
        >
          Timeline ansehen →
        </Link>
      </div>
      <p className="text-sm text-fg-muted">
        Schau dir gerne schon mal die Timeline an, damit du weißt, was kommt.
      </p>
    </div>
  );
}
